import {ResourceParams} from "../resources";

export type PurchasingProductManagersResourceType =
  'technical-parameters' |
  'product-packages';

export const purchasingProductManagers: {
  [key in PurchasingProductManagersResourceType]: ResourceParams
} = {
  'technical-parameters': {
    key: 'technical-parameters',
    name: 'Тех. документация продукта',
    path: 'technical-parameters'
  },
  'product-packages': {
    key: 'product-packages',
    name: 'Габариты и Упаковка',
    path: 'product-packages'
  }
}
